import "./PrimaryInput.css"

export default function PrimaryInput(props) {
    const onChange = props.onChange
    const type = props.type
    const name = props.name
    const placeholder = props.placeholder
    const accept = props.accept
    const extraClassName = (props.extraClassName || "").trim()
    const value = props.children

    let className = "shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:shadow-outline"
    className = [className, extraClassName].join(" ")
    return (
        <input
            type={type}
            name={name}
            placeholder={placeholder}
            accept={accept}
            value={value}
            onChange={onChange}
            className={className}
        />
    )
}
